import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "När måste jag anmäla ny ägare eller styrelseledamot?";
const SHORT_ANSWER = "Direkt vid förändringen. Kommunen ska kunna pröva den nya personens lämplighet enligt PBI-kretsen.";

export const Route = createFileRoute("/fraga/nar-behover-jag-anmala-ny-agare")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "När måste jag anmäla ny ägare eller styrelseled…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Att inte anmäla ändringar i PBI-kretsen ses som allvarligt och kan leda till varning eller återkallat tillstånd. Den nya personen prövas mot vandel, ekonomi och tidigare brott."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "PBI-kretsen – allt du behöver veta" }}
      related={[{"to": "/fraga/far-jag-saljs-pa-bordet", "label": "Får gäster själva fylla på drinkar vid bordet?"}, {"to": "/fraga/vad-betyder-personlig-lamplighet", "label": "Vad betyder personlig lämplighet enligt alkohollagen?"}, {"to": "/fraga/hur-anmaler-jag-andringar", "label": "Hur anmäler jag ändringar i min verksamhet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "När måste jag anmäla ny ägare eller styrelseledamot?" },
      { name: "description", content: "Direkt vid förändringen. Kommunen ska kunna pröva den nya personens lämplighet enligt PBI-kretsen." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/nar-behover-jag-anmala-ny-agare" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/nar-behover-jag-anmala-ny-agare" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/nar-behover-jag-anmala-ny-agare",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "När måste jag anmäla ny ägare eller styrelseled…", url: "https://alkoholprovet.se/fraga/nar-behover-jag-anmala-ny-agare" },
      ]),
    ],
  }),
});
